import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricWidget = ({ metric, onDragStart, onDragEnd, isDragging }) => {
  const getTrendIcon = (trend) => {
    if (trend > 0) return 'TrendingUp';
    if (trend < 0) return 'TrendingDown';
    return 'Minus';
  };

  const getTrendColor = (trend) => {
    if (trend > 0) return 'text-success';
    if (trend < 0) return 'text-destructive';
    return 'text-muted-foreground';
  };

  const getTrendBgColor = (trend) => {
    if (trend > 0) return 'bg-success/10';
    if (trend < 0) return 'bg-destructive/10';
    return 'bg-muted/10';
  };

  const formatValue = (value, type) => {
    switch (type) {
      case 'currency':
        return new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }).format(value || 0);
      case 'percentage':
        return `${value || 0}%`;
      case 'number':
        return (value || 0).toLocaleString('pt-BR');
      default:
        return value || 0;
    }
  };

  const getIconColor = (iconColor) => {
    // Mapear cores CSS para classes Tailwind
    if (iconColor.includes('primary')) return 'text-primary';
    if (iconColor.includes('success')) return 'text-success';
    if (iconColor.includes('warning')) return 'text-warning';
    if (iconColor.includes('accent')) return 'text-accent';
    return 'text-primary';
  };

  return (
    <div
      className={`group relative bg-card border border-border rounded-xl p-5 cursor-move transition-all duration-300 hover:shadow-lg hover:-translate-y-1 overflow-hidden ${
        isDragging ? 'opacity-50 scale-95 shadow-2xl' : 'hover:shadow-md'
      }`}
      draggable
      onDragStart={(e) => onDragStart(e, metric.id)}
      onDragEnd={onDragEnd}
    >
      {/* Background decoration */}
      <div className={`absolute top-0 right-0 w-32 h-32 ${metric.iconBg} rounded-full blur-3xl opacity-20 -mr-16 -mt-16 group-hover:opacity-30 transition-opacity`}></div>

      <div className="relative">
        {/* Header */}
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center space-x-3">
            <div className={`p-2.5 rounded-xl ${metric.iconBg} group-hover:scale-110 transition-transform duration-300`}>
              <Icon name={metric.icon} size={22} className={getIconColor(metric.iconColor)} />
            </div>
            <div>
              <h3 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-1">
                {metric.title}
              </h3>
              <p className="text-2xl font-bold text-foreground transition-colors">
                {formatValue(metric.value, metric.type)}
              </p>
            </div>
          </div>
          
          {/* Drag handle */}
          <div className="opacity-0 group-hover:opacity-100 transition-opacity">
            <Icon name="GripVertical" size={16} className="text-muted-foreground" />
          </div>
        </div>

        {/* Trend indicator */}
        <div className="flex items-center justify-between">
          <div className={`flex items-center space-x-2 px-3 py-1.5 rounded-lg ${getTrendBgColor(metric.trend)}`}>
            <Icon 
              name={getTrendIcon(metric.trend)} 
              size={14} 
              className={getTrendColor(metric.trend)} 
            />
            <span className={`text-sm font-semibold ${getTrendColor(metric.trend)}`}>
              {Math.abs(metric.trend || 0)}%
            </span>
          </div>
          
          <span className="text-xs text-muted-foreground">vs mês anterior</span>
        </div>

        {/* Mini chart placeholder */}
        {metric.chart && (
          <div className="mt-4 h-16 bg-muted/20 rounded-lg flex items-center justify-center border border-border/50">
            <div className="flex items-center space-x-2 text-xs text-muted-foreground">
              <Icon name="BarChart3" size={14} />
              <span>Gráfico em miniatura</span>
            </div>
          </div>
        )}

        {/* Hover effect overlay */}
        <div className="absolute inset-0 bg-primary/5 opacity-0 group-hover:opacity-100 transition-opacity rounded-xl pointer-events-none"></div>
      </div>
    </div>
  );
};

export default MetricWidget;